module.exports = __webpack_public_path__ + "static/img/1692694702918.e854b791.jpg";